import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './Login.css';
import ModalPopupMessage from '../components/modal/ModalPopupMessage';
let packageJson = require('../../package.json')

function Login(props) {
    const accesspanelRef = useRef(null)
    const [platform, setPlatform] = useState(true)
    const [plant_info, setPlant_info] = useState({
        sitename_en: '-',
        sitename_th: '-',
        sitecode_text: '-',
        app_version: '-',
    })

    const [remember_me, setRemember_me] = useState({
        rem: false,
        user: '',
        pass: ''
    })

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const getRememberObject = () => {
        const remString = localStorage.getItem('cpfcenter-rem');
        if (remString !== "undefined" && remString !== null) {
            const userRem = JSON.parse(remString);
            return userRem
        }
        return {
            rem: false,
            user: '',
            pass: ''
        }
    };

    const saveRemember = userRem => {
        localStorage.setItem('cpfcenter-rem', JSON.stringify(userRem));
    };

    const saveLocalSessionObject = (session_name, userToken) => {
        sessionStorage.setItem(session_name, JSON.stringify(userToken));
    };


    useEffect(() => {
        setRemember_me(getRememberObject())
        saveLocalSessionObject('cpfcenter-token4', {
            id: '',
            username: '',
            password: '',
            status: '',
            user_role: '',
            firstname: '',
            lastname: '',
            cod_date: '',
            logintime: '',
            user_mode: '',
            view_mode: '',
            sitecode: '',
            sitescope_arr: [],
            sitescope_str: '',
            sitename_en: '',
            sitename_th: '',
            proxy: '',
            group_handle: [],
            back_url: '',
            platform: ''
        })

        if (window.location.href.includes('cpfsolar.sspv1.co.th') ||
            window.location.href.includes('160.187.248.70') ||
            window.location.href.includes('localhost:3000') ||
            window.location.href.includes(':3000')) {
            setPlatform(true)
        } else {
            setPlatform(false)
            api_load_plant_info()
        }
    }, []);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function callback_signin(permitdata, config) {
        props.callback_signin(permitdata, config);
    }

    function api_login() {
        var formelement = accesspanelRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            var url = process.env.REACT_APP_API_URL + "/proxy/center/api/authentication/signin"
            if (!platform) {
                url = process.env.REACT_APP_API_URL + "/api/authentication/signin"
            }
            const formData = new FormData(formelement);
            axios.post(url, formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer GrU5w8y8CKjQPoBCfkjI8fAaoFUP6KLg5xG6h0pfJ2pbfgkPKCc8k522Z7wxy6xb"
                },
            })
                .then((response) => {
                    if (response.data.status === 'OK') {
                        if (remember_me.rem === true) {
                            saveRemember(remember_me)
                        } else {
                            saveRemember({
                                rem: false,
                                user: '',
                                pass: ''
                            })
                        }
                        saveLocalSessionObject('cpfcenter-token4', response.data.user)
                        callback_signin(response.data.user, response.data.config)
                    } else if (response.data.status === 'login-fail') {
                        saveLocalSessionObject('cpfcenter-token4', {
                            id: '',
                            username: '',
                            password: '',
                            status: '',
                            user_role: '',
                            firstname: '',
                            lastname: '',
                            cod_date: '',
                            logintime: '',
                            user_mode: '',
                            view_mode: '',
                            sitecode: '',
                            sitescope_arr: [],
                            sitescope_str: '',
                            sitename_en: '',
                            sitename_th: '',
                            proxy: '',
                            group_handle: [],
                            back_url: '',
                            platform: ''
                        })
                        setModal_popup({ modaltype: 'modal-warning', headers: 'Unauthorized', message: response.data.message, enable: true });
                    } else {
                        saveLocalSessionObject('cpfcenter-token4', {
                            id: '',
                            username: '',
                            password: '',
                            status: '',
                            user_role: '',
                            firstname: '',
                            lastname: '',
                            cod_date: '',
                            logintime: '',
                            user_mode: '',
                            view_mode: '',
                            sitecode: '',
                            sitescope_arr: [],
                            sitescope_str: '',
                            sitename_en: '',
                            sitename_th: '',
                            proxy: '',
                            group_handle: [],
                            back_url: '',
                            platform: ''
                        })
                        setModal_popup({ modaltype: 'modal-error', headers: 'Unauthorized', message: response.data.message, enable: true });
                    }
                })
                .catch((err) => {
                    setModal_popup({ modaltype: 'modal-error', headers: 'Error', message: err.message, enable: true });
                });
        }
    }

    function handlechange_login(id, val) {
        if (id === 'user') {
            setRemember_me((prevState) => ({
                ...prevState,
                user: val,
            }));
        } else if (id === 'pass') {
            setRemember_me((prevState) => ({
                ...prevState,
                pass: val,
            }));
        } else if (id === 'rem') {
            setRemember_me((prevState) => ({
                ...prevState,
                rem: val,
            }));
        }
    }

    function api_load_plant_info() {
        const formData = new FormData();
        axios.post(process.env.REACT_APP_API_URL + "/api/authentication/plantinfo", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer GrU5w8y8CKjQPoBCfkjI8fAaoFUP6KLg5xG6h0pfJ2pbfgkPKCc8k522Z7wxy6xb"
            },
        })
            .then((response) => {
                if (response.data.status === 'OK') {
                    setPlant_info({
                        sitename_en: response.data.sitename_en,
                        sitename_th: response.data.sitename_th,
                        sitecode_text: response.data.sitecode_txt,
                        app_version: response.data.app_version,
                    })
                } else {

                }
            })
            .catch((err) => {

            });
    }


    return (
        <div id="mainroot" className="root front-container">
            <section id="content" className="content">
                <div className="content__boxed  min-vh-100 d-flex flex-column align-items-center justify-content-center login-wrapper-out">
                    <div className='login-wrapper px-0'>
                        <div className='d-none d-lg-block login-img-wrapper '>
                            <img className='login-img' src={"/images/service-solar-202403273074119.webp"} />
                            <h4 className="welcome-text1 font-sarabun fw-600">Welcome to </h4>
                            {
                                platform ?
                                    <h5 className="welcome-text2 font-sarabun fw-600">CPF Central Solar Monitoring System</h5>
                                    :
                                    <h5 className="welcome-text2 font-sarabun fw-600">CPF Local Solar Monitoring System</h5>
                            }
                            <div className='welcome-text3 d-block'>
                                <h5 className="font-sarabun fw-600">Energy</h5>
                                <h5 className="font-sarabun fw-600">Saving</h5>
                                <h5 className="font-sarabun fw-600">CO<sub>2</sub> Reduction</h5>
                                <h5 className="font-sarabun fw-600">Performance</h5>
                            </div>
                        </div>
                        <div className="card card-login">
                            <div className="card-body">
                                <div className="">
                                    <h5 className="mb-1 mt-1 font-sarabun fw-600 text-blue">
                                        SHINING SPV 1 CO., LTD.</h5>
                                    <h6 className="mb-1 mt-1 font-sarabun fw-600">บริษัท ไชนิง เอสพีวี 1 จำกัด</h6>
                                    {
                                        platform ?
                                            <>
                                                <h5 className="mb-1 mt-3 font-sarabun fw-600 app-location">
                                                    CPF Central Solar Monitoring System Phase 3</h5>
                                                <h6 className="mb-1 mt-0 font-sarabun fw-600 text-grey">
                                                    ศูนย์กลางข้อมูลระบบผลิตพลังงานไฟฟ้าแสงอาทิตย์ เฟส 3</h6>
                                            </>
                                            :
                                            <>
                                                <h5 className="mb-1 mt-3 font-sarabun fw-600 app-location">
                                                    CPF Local Solar Monitoring System</h5>
                                                <h6 className="mb-1 mt-0 font-sarabun fw-600 text-grey">
                                                    สถานที่ติดตั้ง : {plant_info.sitename_th}</h6>
                                            </>
                                    }
                                </div>
                                <div className="text-center">
                                    <hr className="mb-3 mt-1"></hr>
                                    <h4 className="" style={{ fontFamily: "Poppins" }}>Hello !</h4>
                                    <h5 className='text-blue'>Login <span className='text-dark'>Your Account</span></h5>
                                </div>
                                <form className="mt-4" ref={accesspanelRef} action="" method="POST" encType="multipart/form-data">
                                    <div className="mb-3">
                                        <input type="text" className="form-control" placeholder="Username" autoFocus
                                            name="username" value={remember_me.user} onChange={(e) => { handlechange_login('user', e.target.value) }} required />
                                    </div>
                                    <div className="mb-3">
                                        <input type="password" className="form-control" placeholder="Password"
                                            name="password" value={remember_me.pass} onChange={(e) => { handlechange_login('pass', e.target.value) }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter")
                                                    api_login();
                                            }}
                                            required />
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox"
                                            name="remember" id="remember" checked={remember_me.rem} onChange={(e) => { handlechange_login('rem', e.target.checked) }} />
                                        <label htmlFor="remember" className="form-check-label" style={{ fontFamily: "Poppins" }} >
                                            Remember me
                                        </label>
                                    </div>
                                    <div className="d-grid mt-5">
                                        <button className="btn btn-info btn-lg" type="button" onClick={() => { api_login() }}>Sign In</button>
                                    </div>
                                </form>
                                <p className="mt-4 mb-0 font-sarabun fw-600">Publish by <b className='text-blue'>Chow Energy PCL.</b></p>
                                <p className='mb-0'>Version {packageJson.version}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}


export default Login